import { FunctionalComponent, h } from 'preact';

import { configGetCountry } from 'common/helper/config/get-country';
import { i18nTranslate } from 'common/helper/i18n/translate';
import { GoogleRecaptchaTemplate } from 'common/module/google/recaptcha/template';
import { LoaderComponent } from 'common/module/loader/component';
import { UserSignInTemplatePropsInterface } from 'common/module/user/sign-in/template-props.interface';

export const UserSignInTemplate2: FunctionalComponent<UserSignInTemplatePropsInterface> = (props) => (
  <div className='authentication authentication--ma'>
    <div className='authentication__close-button' onClick={props.onClose}>
      {i18nTranslate('Close')}
    </div>
    <div className='authentication__content'>
      <h2 className='authentication__heading'>{i18nTranslate('Sign in')}</h2>
      {props.error && <div className='authentication__error--general'>{props.error}</div>}
      <div className='authentication__form'>
        <div className='authentication__input-area'>
          <div className='authentication__input-label'>{i18nTranslate('Enter your email')}</div>
          <input
            type='text'
            className='authentication__input'
            value={props.fields.email}
            onKeyUp={(e) => props.onKeyUpInput(e)}
            onChange={(e: Event) => props.onChangeInput(e, 'email')}
          />
          <div className='authentication__error'>{props.fieldErrors.email}</div>
        </div>
        <div className='authentication__input-area'>
          <div className='authentication__input-label'>{i18nTranslate('Enter your password')}</div>
          <input
            type='password'
            className='authentication__input'
            value={props.fields.password}
            onKeyUp={(e) => props.onKeyUpInput(e)}
            onChange={(e: Event) => props.onChangeInput(e, 'password')}
          />
          <div className='authentication__error'>{props.fieldErrors.password}</div>
        </div>
        <div className='authentication__forgot-password' onClick={props.onClickForgotPassword}>
          {i18nTranslate('Forgot password?')}
        </div>

        <div className='authentication__input-area'>
          <GoogleRecaptchaTemplate {...props.captcha} />

          <div className='authentication__error'>{props.fieldErrors.captcha_token}</div>
        </div>

        <div className='authentication__form-submit'>
          <button className='button authentication__button' onClick={props.onClickLogin}>
            {i18nTranslate('Log in')}
          </button>
        </div>

        <div className='authentication__create-account'>
          <div className='authentication__create-account-text'>{i18nTranslate('Not registered yet?')}</div>
          <div className='authentication__create-account-link' onClick={props.onClickCreateAccount}>
            {i18nTranslate('Create account')}
          </div>
        </div>

        <div className='authentication__divider'>
          <span className='authentication__divider-txt'>{i18nTranslate('or')}</span>
        </div>

        <div className='authentication__compliance-text'>
          {i18nTranslate(
            'Conformément à la loi 09-08, vous disposez d’un droit d’accès, de rectification et ' +
              'd’opposition au traitement de vos données personnelles. Ce traitement a été autorisé par la CNDP sous ' +
              'le n° D-M-527/2018'
          )}
        </div>

        {props.isAdditionalConditionEnabled && (
          <div className='authentication__policy-check authentication__policy-check--signin'>
            <div
              className='authentication__checkbox-area authentication__general-condition'
              onClick={props.onClickTermsAndConditions}
            >
              <div
                className={`authentication__checkbox
                  ${props.fields.termsAndConditions ? 'authentication__checkbox--checked' : ''}`}
              >
                <span
                  className='svg'
                  dangerouslySetInnerHTML={{
                    __html: `
                    <svg viewBox='0 0 12 9' class='authentication__checkbox-icon'>
                      <use xlink:href='#svg-check-icon'></use>
                    </svg>
                  `,
                  }}
                />
              </div>
              <div className='authentication__checkbox-text'>
                {i18nTranslate('I have read and I accept the ')}
                <a href={configGetCountry().termsUrl} target='_blank' className='link' rel='noreferrer'>
                  {i18nTranslate('general conditions of use ')}
                </a>
                {i18nTranslate(', in particular, the mention relating to the protection of personal data')}
              </div>
            </div>
            <div className='authentication__checkbox-area' onClick={props.onClickUseEmail}>
              <div
                className={`authentication__checkbox
                  ${props.fields.useEmail ? 'authentication__checkbox--checked' : ''}`}
              >
                <span
                  className='svg'
                  dangerouslySetInnerHTML={{
                    __html: `
                    <svg viewBox='0 0 12 9' class='authentication__checkbox-icon'>
                      <use xlink:href='#svg-check-icon'></use>
                    </svg>
                  `,
                  }}
                />
              </div>
              <div className='authentication__checkbox-text'>
                {i18nTranslate('I have read and I accept to receive advertising messages')}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>

    <div
      className={`authentication__btn authentication__btn--facebook
        ${
          props.isAdditionalConditionEnabled && (!props.fields.useEmail || !props.fields.termsAndConditions)
            ? 'authentication__btn--disabled'
            : ''
        }`}
      onClick={props.onClickSignInFacebook}
    >
      <span
        className='svg'
        dangerouslySetInnerHTML={{
          __html: `
            <svg viewBox='0 0 12 23' class='authentication__btn-icon authentication__btn-icon--fb'>
              <use xlink:href='#svg-facebook'></use>
            </svg>
          `,
        }}
      />
      <span className='authentication__btn-txt authentication__btn-txt--fb'>
        {i18nTranslate('Sign in with Facebook')}
      </span>
    </div>
    <div
      className={`authentication__btn authentication__btn--google
        ${
          props.isAdditionalConditionEnabled && (!props.fields.useEmail || !props.fields.termsAndConditions)
            ? 'authentication__btn--disabled'
            : ''
        }`}
      onClick={props.onClickSignInGoogle}
    >
      <span
        className='svg'
        dangerouslySetInnerHTML={{
          __html: `
            <svg viewBox='0 0 22 22' class='authentication__btn-icon authentication__btn-icon--google'>
              <use xlink:href='#svg-googleplus'></use>
            </svg>
          `,
        }}
      />
      <span className='authentication__btn-txt'>{i18nTranslate('Sign in with Google')}</span>
    </div>
    <LoaderComponent isEnabled={props.loaderEnabled} isCentered={true} />
  </div>
);
